const tooltipMatTableOver = {
  delete: 'Eliminar',
  edit: 'Editar',
  true: 'Guardar',
  false: 'Eliminar',
  cancel: 'Cancelar',
  add: 'Agregar'
};

export default tooltipMatTableOver;
